<template>
    <router-view />
</template>

<script>
import { checkToken } from '../src/utils/auth'

export default {
  mounted () {
    const autoLogin = JSON.parse(window.localStorage.getItem('autoLogin'))
    setTimeout(() => {
      if (
        autoLogin &&
        this.$route.path !== '/shopImpower' &&
        this.$route.path !== '/rechargeRedirect' &&
        this.$route.path !== '/404') {
        checkToken()
      }
    }, 200)
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
}
// 右键菜单 start
.vue-contextmenu-listWrapper[data-v-1931f86e] {
  padding: 0;
  border-radius: 5px !important;
  box-shadow: 0 1px 1px 0 #00000042 !important;
  font-size: 12px !important;
  font-family: auto;
  .context-menu-list[data-v-1931f86e] {
    margin: 0;
    padding: 5px 0;
    border-radius: 5px;
    &:hover {
      color: #FFF;
      background: #409EFF;
    }
    .nav-name-right[data-v-1931f86e] {
      display: inline;
    }
  }
}
// 右键菜单 end

// tag标签
.seller-tag {
  display: inline-block;
  margin-top: 3px;
  padding: 0 5px 1px 0;
  border-radius: 5px;
  color: #FFF;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  background: #68B0AB;
  &::before {
    margin-right: 5px;
    padding: 0 3px 1px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    color: #FFF;
    background: #006A71;
  }
}

// 图片预览弹窗样式
.el-image-viewer__close {
  right: 60px;
  opacity: 1;
}
.el-icon-circle-close {
  padding: 3px;
  border-radius: 50%;
  color: #68B0AB;
  font-size: 40px;
  font-weight: 600;
  background: #FFF;
  &:hover {
    color: #006A71;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue